import { Classes, FormGroup } from "@blueprintjs/core";
import { Entity, Field } from "typegraph";

import { ID } from "common/entities/IEntity";
import DropdownSelect from "common/form/widgets/common/DropdownSelect";
import IOption from "common/models/IOption";
import TokenSession from "core/util/session/TokenSession";
import EntitySelect from "../../entitySelect/EntitySelect";
import { ConditionTypeRegistry } from "../ConditionTypeRegistry";
import { IConditionType } from "../IConditionType";

type ListOperator = "ANY" | "ALL" | "ONLY" | "NONE";

interface IRolesCondition {
	operator: ListOperator;
	names: string[];
}

@Entity({many: "roles"})
class Role {
	@Field() public id: ID;
	@Field() public name: string;
	@Field() public displayName: string;
}

// TODO value as external ID
const RolesEntitySelect = EntitySelect.withOptions({entity: Role, type: 'many', getValue: (role) => role.name, getText: (role) => role.displayName});

const operators: Array<IOption<ListOperator>> = [
	{value: 'ANY', label: 'Any'},
	{value: 'ALL', label: 'All'},
	{value: 'ONLY', label: 'Only'},
	{value: 'NONE', label: 'None'}
];

const RolesConditionType: IConditionType<IRolesCondition> = {
	type: "roles",
	label: "Roles",
	icon: "person",
	evaluate: ({operator, names}) => {
		if (!names || names.length < 1) {
			return true;
		}

		const user = TokenSession.getUser();

		if (!user) {
			return false;
		}

		const roles = user.getRoles();

		switch(operator) {
			case 'ALL':
				for (const name of names) {
					if (roles.indexOf(name) < 0) {
						return false;
					}
				}
				return true;
			case 'NONE':
				for (const name of names) {
					if (roles.indexOf(name) > -1) {
						return false;
					}
				}
				return true;
			case 'ONLY':
				return roles.every((role) => names.indexOf(role) > -1);
			case 'ANY':
				return names.some((name) => roles.indexOf(name) > -1);
			default:
				return true;
		}
	},
	renderField: (value, onChange) => (
		<div>
			<FormGroup label="Operator">
				<DropdownSelect
					options={operators}
					onChange={(operator) => onChange({...value, operator})}
					value={value.operator}
				/>
			</FormGroup>
			<FormGroup label="Roles">
				<RolesEntitySelect
					formData={value.names || []}
					onChange={(names) => onChange({...value, names})}
					uiSchema={undefined}
					idSchema={undefined}
				/>
			</FormGroup>
		</div>
	),
	renderPreview: (value) => (
		<div>
			{`User has ${value.operator} of Roles: ${value.names && value.names.join(', ')}`}
			<div className={Classes.TEXT_MUTED}>{`Current user has roles: ${TokenSession.getUserRoles().join(', ')}`}</div>
		</div>
	),
	getInitialValue: () => ({operator: "ANY", names: []})
};

export default ConditionTypeRegistry.register(RolesConditionType);



// WEBPACK FOOTER //
// ./src/common/form/fields/condition/conditionTypes/RolesCondition.reg.tsx